import { Link, useNavigate, useLocation } from "react-router-dom";
import MainContent from "../../../layouts/maincontent/MainContent";
import Lottie from "react-lottie";
import messageConfirmation from "../../../lotties/message-confirmation.json";
import styleMessageConfirmation from "./MessageConfirmation.module.css";
import React, { useEffect, useState } from "react";
import { get } from "../../../adapters/xhr/api";

function MessageConfirmation() {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: messageConfirmation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const [successMessage, setSuccessMessage] = useState(
    location.state?.message || null,
  );

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified =
         response?.data?.phone_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        navigate("/tax-dispute-request/list-data");
        setSuccessMessage(null);
      }, 5000);

      return () => clearTimeout(timer); // Cleanup on unmount
    }
  }, [navigate, successMessage]);
  return (
    <MainContent>
      <section className={styleMessageConfirmation["confirm-section"]}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-5 col-12">
              <div className={`card ${styleMessageConfirmation["card"]}`}>
                <div className="text-center pt-5">
                  <Lottie width="50%" options={defaultOptions} />
                </div>
                <div
                  className={`${styleMessageConfirmation["card-body"]} card-body`}
                >
                  {successMessage && (
                    <h3
                      className={`${styleMessageConfirmation.order_message} text-center mt-5 fw-bolder mb-5`}
                    >
                      {successMessage}
                    </h3>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default MessageConfirmation;
